import _ from 'lodash';

// IMPORTANT: If uses band id that not found in DB, than error occurs
export const defaultBands = {
  246: {
    label: 'Band 48',
    checked: true,
    disabled: true,
    bandId: 246
  },
  // 247: {
  //   label: 'Band 50',
  //   checked: false,
  //   disabled: false,
  //   bandId: 247
  // }
};

export const formatBands = bands => {
  // get only ids from band list
  const bandsIds = _.map(bands, 'bandid');

  // iterate default bands and prepare values
  const bandList = _.mapValues(defaultBands, (value, key) => {
    const numKey = Number(key);
    const newValue = { ...value, id: numKey };
    if (numKey !== 246) {
      newValue.checked = _.indexOf(bandsIds, numKey) > -1;
    }
    return newValue;
  });

  // convert object to array before return
  return _.values(bandList);
};

export const getModelBands = bands => {
  const checkedBands = _.filter(bands, 'checked');
  let arr = [];

  _.forEach(checkedBands, band => {
    arr.push({ bandid: band.id });
  });

  return arr;
};

export const getBandsAsString = bands => {
  let arr = [];

  _.forEach(bands, band => {
    const bandInfo = defaultBands[band.bandid];
    const bandTitle = bandInfo ? bandInfo.label : 'Wrong Band ID';
    arr.push(bandTitle);
  });

  return arr.join(', ');
};



// WEBPACK FOOTER //
// ./src/helpers/Bands.js